// src/translations.js

const translations = {
  en: {
    category: 'Category',
    subCategory: 'Sub-category',
    brand: 'Brand',
    material: 'Material',
    bulbType: 'Bulb Type',
    barcode: 'Barcode',
    viewOnWebsite: 'View on Website',
    searchWithPicture: 'Search with this picture',
    noProductsFound: 'No products found.',
    unnamedProduct: 'Unnamed Product',
    unknown: 'Unknown',
    uncategorized: 'Uncategorized',
    uploading: 'Uploading...',
    importProducts: 'Import Products from CSV or Excel',
    uploadProductImage: 'Upload Product Image',
    login: 'Login',
    cancel: 'Cancel',
    search: 'Search',
    errorUploadingImage: 'An error occurred while uploading the image.',
    productFinder: 'Product Finder',
    loginFunctionality: 'Login functionality will be implemented later.',
    // New translations for settings
    settings: 'Settings',
    resultsMode: 'Results Mode',
    defaultMode: 'Default (same number for all categories)',
    customMode: 'Custom (set per category)',
    defaultResultsForAll: 'Default results for all categories',
    furnitureResults: 'Furniture results count',
    lightResults: 'Light results count',
    accessoriesResults: 'Accessories results count',
    general: 'General',
    appearance: 'Appearance',
    enableNotifications: 'Enable Notifications',
    resetSettings: 'Reset Settings',
    resetSettingsConfirmation: 'Are you sure you want to reset all settings to default?',
    themeSelection: 'Theme Selection',
    lightMode: 'Light',
    darkMode: 'Dark',
    autoMode: 'Auto',
    fontSize: 'Font Size',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    results: 'Results',
    save: 'Save',
    // New translations for General Settings
    dataManagement: 'Data Management',
    clearCache: 'Clear Cache',
    clearCacheConfirmation: 'Are you sure you want to clear the cache?',
    cacheCleared: 'Cache cleared successfully!',
    dialogWillClose: 'Dialog will close automatically',
    exportData: 'Export Data',
    // New translations for Appearance Settings
    layoutSelection: 'Layout Selection',
    bottomNavOnly: 'Bottom Navigation Bar Active Only',
    centerButtonsOnly: 'Centered Buttons Active Only',
    bothActive: 'Both Active',
    // New translations for barcode scanning
    scanBarcode: 'Scan Barcode',
    scannerInitError: 'Failed to initialize the scanner. Please try again.',
    noProductFound: 'No product found for the scanned barcode.',
    errorScanningBarcode: 'An error occurred while scanning the barcode.',
    // Pages (content)
    home: 'Home',
    how: 'How?',
    about: 'About',
    upload: 'Upload',
    // Added Language Selection
    languageSelection: 'Language Selection',
    // New Translations for contentpages
    contentNotFound: 'Content not found.',
    fetchError: 'An error occurred while fetching content.',
    noServerResponse: 'No response received from the server.',
    requestSetupError: 'Error setting up the request.',
    retry: 'Retry',
    // New translations for History Panel
    history: 'History',
    searchHistory: 'Search History',
    noHistoryAvailable: 'No history available.',
    view: 'View',
    delete: 'Delete',
    deleteItem: 'Delete Item',
    confirmDeletion: 'Are you sure you want to delete this item?',
    deleteItems: 'Delete Items',
    confirmDeleteMultiple: 'Are you sure you want to delete',
    items: 'items',
    // NEW: Proper singular/plural delete translations
    deleteOneItem: 'Delete Item',
    deleteMultipleItems: 'Delete Items',
    confirmDeleteOneItem: 'Are you sure you want to delete this item?',
    confirmDeleteMultipleItems: 'Are you sure you want to delete {count} items?',
    // NEW: Time filter translations
    today: 'Today',
    yesterday: 'Yesterday',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    filterByTime: 'Filter by time',
    noResultsForFilter: 'No results for selected time period',
    // New translations for product details
    color: 'Color',
    height: 'Height',
    width: 'Width',
    length: 'Length',
    success: 'Success',
    error: 'Error',
    errorSearchingPicture: 'An error occurred while searching with the picture.',
    // New translations for 3D related pages and buttons
    threeD: '3D',
    threeDViewer: '3D Viewer',
    place3DInYourPhoto: 'Place 3D In Your Photo',
    neon3DButtonText: '3D',
    qrCodeForThreeDViewer: 'QR Code for 3D Viewer',
    // NEW: Additional 3D translations
    r3fViewer: 'R3F Viewer',
    noProductSelected: 'No product selected.',
    loading3DModel: 'Loading 3D model...',
    select3DModel: 'Select a 3D Model',
    selectVersion: 'Select a Version',
    version: 'Version',
    // NEW: QR Code translations
    loadingQRCode: 'Loading QR Code...',
    qrCodeError: 'Error generating QR code.',
    // NEW: Translation for QR Code modal title
    qrCodeModalTitle: 'One-time QR Code',
    // NEW: Translation for no available 3D products
    noAvailable3DProducts: 'No available 3D products found.',
    // NEW: Change Model button translation
    changeModel: 'Change Model',
    // NEW: General loading translation
    loading: 'Loading...'
  , clear: 'Clear'
  , perPage: 'per page'
  , showing: 'Showing'
  , of: 'of'
  , noModelsFound: 'No models found'
  , searchModels: 'Search models...'
  , next: 'Next'
  , previous: 'Previous'
  },
  ka: {
    category: 'კატეგორია',
    subCategory: 'ქვე-კატეგორია',
    brand: 'ბრენდი',
    material: 'მასალა',
    bulbType: 'ნათურის ტიპი',
    barcode: 'კოდი',
    viewOnWebsite: 'დაათვალიერე საიტზე',
    searchWithPicture: 'მოძებნე გამოსახულებით',
    noProductsFound: 'პროდუქტები ვერ მოიძებნა.',
    unnamedProduct: 'არასახელებელი პროდუქტი',
    unknown: 'უცნობი',
    uncategorized: 'არანაწილებული',
    uploading: 'ატვირთვა...',
    importProducts: 'პროდუქტების იმპორტი CSV ან Excel ფაილიდან',
    uploadProductImage: 'გამოსახულების ატვირთვა',
    login: 'შესვლა',
    cancel: 'გაუქმება',
    search: 'ძებნა',
    errorUploadingImage: 'გამოსახულების ატვირთვისას მოხდა შეცდომა.',
    productFinder: 'პროდუქტის მოძებნა',
    loginFunctionality: 'ავტორიზაციის ფუნქცია დაემატება მოგვიანებით.',
    // New translations for settings
    settings: 'პარამეტრები',
    resultsMode: 'რეჟიმი',
    defaultMode: 'ძირითადი (რაოდენობა ყველა კატეგორიისთვის)',
    customMode: 'ინდივიდუალური (კატეგორიების მიხედვით)',
    defaultResultsForAll: 'ნაგულისხმევი რაოდენობა ყველა კატეგორიისთვის',
    furnitureResults: 'ავეჯის შედეგების რაოდენობა',
    lightResults: 'განათების შედეგების რაოდენობა',
    accessoriesResults: 'აქსესუარების შედეგების რაოდენობა',
    general: 'ზოგადი',
    appearance: 'დიზაინი',
    enableNotifications: 'შეტყობინებების მართვა',
    resetSettings: 'პარამეტრების აღდგენა',
    resetSettingsConfirmation: 'დარწმუნებული ხართ, რომ გსურთ ყველა პარამეტრის აღდგენა?',
    themeSelection: 'თემის არჩევა',
    lightMode: 'ღია',
    darkMode: 'მუქი',
    autoMode: 'ავტომატური გადართვა',
    fontSize: 'ფონტის ზომა',
    small: 'პატარა',
    medium: 'საშუალო',
    large: 'დიდი',
    results: 'შედეგები',
    save: 'შენახვა',
    // New translations for General Settings
    dataManagement: 'მონაცემთა მართვა',
    clearCache: 'ქეშის გასუფთავება',
    clearCacheConfirmation: 'დარწმუნებული ხართ, რომ გსურთ ქეშის გასუფთავება?',
    cacheCleared: 'ქეში წარმატებით გასუფთავდა!',
    dialogWillClose: 'ფანჯარა ავტომატურად დაიხურება',
    exportData: 'მონაცემთა ექსპორტი',
    // New translations for Appearance Settings
    layoutSelection: 'ჩვენების არჩევა',
    bottomNavOnly: 'ქვედა ნავიგაციის ველია აქტიური',
    centerButtonsOnly: 'ზედა ნავიგაციის ველია აქტიური',
    bothActive: 'ორივე აქტიურია',
    // New translations for barcode scanning
    scanBarcode: 'ბარკოდით ძებნა',
    scannerInitError: 'სკანერის ჩართვაში ვიღებთ შეცდომას. გთხოვთ, სცადოთ თავიდან.',
    noProductFound: 'პროდუქტის ბარკოდი ვერ მოიძებნა.',
    errorScanningBarcode: 'ბარკოდის მოძებნისას მოხდა შეცდომა.',
    // Pages (content)
    home: 'მთავარი',
    how: 'როგორ?',
    about: 'ჩვენ შესახებ',
    upload: 'ატვირთვა',
    // Added Language Selection
    languageSelection: 'ენის არჩევა',
    // New Translations for contentpages
    contentNotFound: 'სტატიები არ მოიძებნა.',
    fetchError: 'შეცდომა ინფორმაციის მიღებისას.',
    noServerResponse: 'სერვერის პასუხი არ მოიძებნა.',
    requestSetupError: 'შეცდომა მოთხოვნის დროს.',
    retry: 'სცადე თავიდან',
    // New translations for History Panel
    history: 'ისტორია',
    searchHistory: 'ძიების ისტორია',
    noHistoryAvailable: 'ისტორია არ არის ხელმისაწვდომი.',
    view: 'ნახვა',
    delete: 'წაშლა',
    deleteItem: 'ჩანაწერის წაშლა',
    confirmDeletion: 'დარწმუნებული ხარ, რომ გსურთ ამ ჩანაწერის წაშლა?',
    deleteItems: 'ჩანაწერის წაშლა',
    confirmDeleteMultiple: 'დარწმუნებული ხარ, რომ გსურთ წაშლა',
    items: 'ელემენტების',
    // NEW: Proper singular/plural delete translations
    deleteOneItem: 'ჩანაწერის წაშლა',
    deleteMultipleItems: 'ჩანაწერების წაშლა',
    confirmDeleteOneItem: 'დარწმუნებული ხართ, რომ გსურთ წაშალოთ ეს ჩანაწერი?',
    confirmDeleteMultipleItems: 'დარწმუნებული ხართ, რომ გსურთ წაშალოთ {count} ჩანაწერი?',
    // NEW: Time filter translations
    today: 'დღეს',
    yesterday: 'გუშინ',
    last7Days: 'ბოლო 7 დღე',
    last30Days: 'ბოლო 30 დღე',
    filterByTime: 'დროით ფილტრაცია',
    noResultsForFilter: 'შერჩეული დროისთვის შედეგები არ მოიძებნა',
    // New translations for product details
    color: 'ფერი',
    height: 'სიმაღლე',
    width: 'სიგანე',
    length: 'სიგრძე',
    success: 'წარმატება',
    error: 'შეცდომა',
    errorSearchingPicture: 'სურათით ძებნისას მოხდა შეცდომა.',
    // New translations for 3D related pages and buttons
    threeD: '3D',
    threeDViewer: '3D მაჩვენებელი',
    place3DInYourPhoto: 'ჩასვი 3D შენს ფოტოში',
    neon3DButtonText: '3D',
    qrCodeForThreeDViewer: 'QR კოდი 3D ვიზუერისთვის',
    // NEW: Additional 3D translations
    r3fViewer: 'R3F მაჩვენებელი',
    noProductSelected: 'პროდუქტი არ გაქვთ არჩეული.',
    loading3DModel: '3D მოდელი იტვირთება...',
    select3DModel: 'აირჩიეთ 3D მოდელი',
    selectVersion: 'აირჩიეთ ვერსია',
    version: 'ვერსია',
    // NEW: QR Code translations
    loadingQRCode: 'QR კოდი იტვირთება...',
    qrCodeError: 'QR კოდის შექმნისას მოხდა შეცდომა.',
    // NEW: Translation for QR Code modal title
    qrCodeModalTitle: 'ერთჯერადი QR კოდი',
    // NEW: Translation for no available 3D products
    noAvailable3DProducts: 'არ არის ხელმისაწვდომი 3D პროდუქტი.',
    // NEW: Change Model button translation
    changeModel: 'შეცვალე მოდელი',
    // NEW: General loading translation
    loading: 'იტვირთება...'
  , clear: 'გასუფთავება'
  , perPage: 'გვერდზე'
  , showing: 'ნაჩვენებია'
  , of: 'დან'
  , noModelsFound: 'მოდელები ვერ მოიძებნა'
  , searchModels: 'მოდელების ძებნა...'
  , next: 'შემდეგი'
  , previous: 'წინა'
  },
};

export default translations;
